import {
  Button,
  FormControl,
  FormLabel,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Textarea
} from '@chakra-ui/react'
import { FC, useRef } from 'react'
import { MdCheckCircle, MdOutlineCancel } from 'react-icons/md'

import FuModalHeader from '@component/FollowUpFornecedor/ModalHeader'

interface Props {
  isOpen: boolean
  tipo: 1 | 2
  count: number
  onClose: () => void
  onSubmit: (obs: string) => void
}

const AprovacaoModal: FC<Props> = ({
  isOpen,
  tipo,
  count,
  onClose,
  onSubmit
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  const handleClose = () => {
    if (textareaRef.current) textareaRef.current.value = ''
    onClose()
  }

  const handleSubmit = () => {
    onSubmit(textareaRef.current?.value ?? '')
    if (textareaRef.current) textareaRef.current.value = ''
  }

  const label = tipo === 1 ? 'item' : 'item'
  const plural = count === 1 ? label : `${label}s`

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      isCentered
      motionPreset="slideInBottom"
      size="xl"
    >
      <ModalOverlay />
      <ModalContent>
        <FuModalHeader
          bg={tipo === 1 ? '#1d5840' : 'red.600'}
          icon={tipo === 1 ? MdCheckCircle : MdOutlineCancel}
          title={
            tipo === 1
              ? `Aprovar ${count} ${plural}`
              : `Recusar ${count} ${plural}`
          }
        />
        <ModalCloseButton color="white" />
        <ModalBody bg="white" py={5}>
          <FormControl>
            <FormLabel fontSize="sm">
              {tipo === 1
                ? 'Observação (opcional)'
                : 'Motivo da recusa (recomendado)'}
            </FormLabel>
            <Textarea
              ref={textareaRef}
              defaultValue=""
              placeholder={
                tipo === 1
                  ? 'Aprovado conforme negociação...'
                  : 'Quantidade acima do contrato vigente...'
              }
              rows={3}
            />
          </FormControl>
        </ModalBody>
        <ModalFooter
          bg="white"
          borderBottomLeftRadius={5}
          borderBottomRightRadius={5}
        >
          <Button colorScheme="blue" mr={3} onClick={handleClose}>
            Cancelar
          </Button>
          <Button
            bg={tipo === 1 ? 'green.600' : 'red.500'}
            color="white"
            leftIcon={
              <Icon as={tipo === 1 ? MdCheckCircle : MdOutlineCancel} />
            }
            _hover={{ bg: tipo === 1 ? 'green.500' : 'red.400' }}
            _active={{ bg: tipo === 1 ? 'green.500' : 'red.400' }}
            onClick={handleSubmit}
          >
            {tipo === 1 ? 'Confirmar Aprovação' : 'Confirmar Recusa'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default AprovacaoModal
